import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs';
// import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class GetExcelService {

  constructor() { }

  basePath$ = this.getBasePath();

  getBasePath(): any {
    return environment.base_path;
  }

  exportExcel(excelData): void {

    const title = excelData.title;
    const header = excelData.headers;
    const data = excelData.data;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelData.title);

    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2a295c' },
        bgColor: { argb: '' },
      };
      cell.font = {
        bold: true,
        color: { argb: 'ffffff' },
        size: 12,
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // worksheet.mergeCells('C1', 'F4');
    // const titleRow = worksheet.getCell('C1');
    // titleRow.value = title;
    // titleRow.font = {
    //   name: 'Calibri',
    //   size: 16,
    //   underline: 'single',
    //   bold: true,
    //   color: { argb: '0085A3' }
    // };
    // titleRow.alignment = { vertical: 'middle', horizontal: 'center' };
    // worksheet.addRow([]);
    // const headerRow = worksheet.addRow(header);
    // headerRow.eachCell((cell) => {
    //   cell.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: '4167B8' },
    //     bgColor: { argb: '' },
    //   };
    //   cell.font = {
    //     bold: true,
    //     color: { argb: 'FFFFFF' },
    //     size: 12,
    //   };
    //   cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    // });


    data.forEach(d => {
       worksheet.addRow(d);

      // const sales = row.getCell(1);
      // let color = 'FF99FF99';
      // if (sales.value === '') {
      //   color = 'FF9999';
      // }

      // sales.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
      // row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    }
    );

    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });

  }


}


